var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DEFAULT_ALERT_TITLE_API, DEFAULT_DURATION } from './ErrorHandlers.constatns';
import { ErrorsCapture } from './ErrorsCapture';
import { isDev } from "./utils/common";
/**
 * @description isTraceable is a decorator to check
 * received URL to match CriticalApiList
 * @param {(args: TCatchApiErrorsParams) => void} fn
 * @return {(args: TCatchApiErrorsParams) => void}
 *
 */
var isTraceable = function (fn) {
    return function (_a) {
        var _b, _c, _d, _e, _f;
        var error = _a.error, CriticalApiList = _a.CriticalApiList, UntraceableApiList = _a.UntraceableApiList, rest = __rest(_a, ["error", "CriticalApiList", "UntraceableApiList"]);
        // удаляем query параметры из url
        var apiUrlWithoutQuery = (_e = (_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.url) === null || _d === void 0 ? void 0 : _d.split('?')) === null || _e === void 0 ? void 0 : _e[0];
        var errorStatus = (_f = error.response) === null || _f === void 0 ? void 0 : _f.status;
        var hasUnprocessedStatus = errorStatus === 401;
        // сравниваем url на идентичность
        var checkLinkSimilarity = function (apiUrl, itemUrl) {
            var _a, _b;
            if (apiUrl === itemUrl)
                return true;
            var isSame = false;
            if (apiUrl && itemUrl) {
                isSame = true;
                // разбиваем url и "маску url" на массивы
                var splitApiUrl = (_a = apiUrl.split('/')) === null || _a === void 0 ? void 0 : _a.filter(Boolean);
                var splitItemUrl_1 = (_b = itemUrl.split('/')) === null || _b === void 0 ? void 0 : _b.filter(Boolean);
                splitApiUrl === null || splitApiUrl === void 0 ? void 0 : splitApiUrl.forEach(function (item, index) {
                    var _a;
                    // сравниваем каждый элемент массивов, splitApiUrl и splitItemUrl
                    // если isSame = false то дальше смысла проверять уже нет, значит какое-то условие не выполнилось
                    // если элемент splitItemUrl содержит ":" значит нам не важно, что находится на этом месте в splitApiUrl
                    // если элемент splitItemUrl НЕ содержит ":", то проверяем на совпадение
                    if (isSame && !((_a = splitItemUrl_1 === null || splitItemUrl_1 === void 0 ? void 0 : splitItemUrl_1[index]) === null || _a === void 0 ? void 0 : _a.includes(':')) && item !== (splitItemUrl_1 === null || splitItemUrl_1 === void 0 ? void 0 : splitItemUrl_1[index])) {
                        isSame = false;
                    }
                });
            }
            return isSame;
        };
        var apiCriticalInfo = CriticalApiList === null || CriticalApiList === void 0 ? void 0 : CriticalApiList.find(function (item) { return checkLinkSimilarity(apiUrlWithoutQuery, item === null || item === void 0 ? void 0 : item.url); });
        var isNeedUntraceableAlert = false;
        var apiIsUntraceable = UntraceableApiList === null || UntraceableApiList === void 0 ? void 0 : UntraceableApiList.some(function (item) {
            var _a;
            var untraceableStatus = !!((_a = item === null || item === void 0 ? void 0 : item.statuses) === null || _a === void 0 ? void 0 : _a.length) ? errorStatus && item.statuses.includes(errorStatus) : true;
            var isUrlMatch = checkLinkSimilarity(apiUrlWithoutQuery, item === null || item === void 0 ? void 0 : item.url);
            var result = isUrlMatch && untraceableStatus;
            isNeedUntraceableAlert = result ? !!item.alert : false;
            return result;
        });
        if (apiCriticalInfo && errorStatus && !apiIsUntraceable && !hasUnprocessedStatus) {
            var apiCriticalStatuses = apiCriticalInfo.statuses;
            var isRequestCritical = !apiCriticalStatuses.length || apiCriticalStatuses.includes(errorStatus);
            fn(__assign({ error: error, errorLevel: isRequestCritical ? "Critical" : "Error" }, rest));
        }
        else if (!apiIsUntraceable && !hasUnprocessedStatus) {
            fn(__assign({ error: error }, rest));
        }
        else if (isNeedUntraceableAlert) {
            fn(__assign(__assign({ error: error }, rest), { isOnlyAlert: true }));
        }
    };
};
/**
 * @description ErrorsCaptureWrapperApi is a wrapper of function ErrorsCapture
 * for checking the criticality of a request with a decorator isTraceable
 * @param {TCatchApiErrorsParams} params
 *
 */
var ErrorsCaptureWrapperApi = function (params) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    isDev() && console.log('ErrorsCaptureWrapperApi params', params);
    var error = params.error, alertConfig = params.alertConfig, sentryExtraInfo = params.sentryExtraInfo, _z = params.showAlertReportBtn, showAlertReportBtn = _z === void 0 ? false : _z, isOnlyAlert = params.isOnlyAlert;
    var _0 = __assign({}, alertConfig), _1 = _0.title, title = _1 === void 0 ? DEFAULT_ALERT_TITLE_API : _1, _2 = _0.duration, duration = _2 === void 0 ? DEFAULT_DURATION : _2;
    var _3 = __assign({}, sentryExtraInfo), _4 = _3.apiUrl, apiUrl = _4 === void 0 ? (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : '-' : _4, _5 = _3.requestType, requestType = _5 === void 0 ? (_f = (_e = (_d = error.response) === null || _d === void 0 ? void 0 : _d.config) === null || _e === void 0 ? void 0 : _e.method) !== null && _f !== void 0 ? _f : '-' : _5, _6 = _3.requestPayload, requestPayload = _6 === void 0 ? ((_h = (_g = error.response) === null || _g === void 0 ? void 0 : _g.config) === null || _h === void 0 ? void 0 : _h.data) ? JSON.stringify((_k = (_j = error.response) === null || _j === void 0 ? void 0 : _j.config) === null || _k === void 0 ? void 0 : _k.data) : '-' : _6, _7 = _3.errorReason, errorReason = _7 === void 0 ? ((_m = (_l = error.response) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.extra) && Object.values((_p = (_o = error.response) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.extra).length ? (_r = (_q = error.response) === null || _q === void 0 ? void 0 : _q.data) === null || _r === void 0 ? void 0 : _r.extra : (_u = (_t = (_s = error.response) === null || _s === void 0 ? void 0 : _s.data) === null || _t === void 0 ? void 0 : _t.message) !== null && _u !== void 0 ? _u : '-' : _7, _8 = _3.errorType, errorType = _8 === void 0 ? ((_w = (_v = error.response) === null || _v === void 0 ? void 0 : _v.data) === null || _w === void 0 ? void 0 : _w.message) ? JSON.stringify((_y = (_x = error.response) === null || _x === void 0 ? void 0 : _x.data) === null || _y === void 0 ? void 0 : _y.message) : "-" : _8;
    var errorText = '';
    if (typeof errorReason !== 'string') {
        var validationErr = errorReason === null || errorReason === void 0 ? void 0 : errorReason.fields;
        var isValidationErrArray = Array.isArray(validationErr);
        var isValidationErrObjects = validationErr && (isValidationErrArray ? validationErr === null || validationErr === void 0 ? void 0 : validationErr.some(function (item) { return typeof item !== 'string'; }) : typeof validationErr !== 'string');
        var isValidationErrStrings = validationErr && (isValidationErrArray ? !(validationErr === null || validationErr === void 0 ? void 0 : validationErr.some(function (item) { return typeof item !== 'string'; })) : typeof validationErr === 'string');
        var validationErrParsed = isValidationErrStrings ? validationErr.join(',') : undefined;
        if (isDev()) {
            console.log('validationErr', validationErr);
            console.log('isValidationErrArray', isValidationErrArray);
            console.log('isValidationErrObjects', isValidationErrObjects);
            console.log('isValidationErrStrings', isValidationErrStrings);
            console.log('validationErrParsed', validationErrParsed);
        }
        if (isValidationErrObjects) {
            // если пришел объект с ключами - выводим их
            Object.values(validationErr).forEach(function (objVal) {
                errorText += "".concat(objVal, " \n");
            });
        }
        else {
            errorText = validationErrParsed ? validationErrParsed : errorReason ? "".concat(JSON.stringify(errorReason)) : error.message;
        }
    }
    else {
        errorText = errorReason !== '-' ? errorReason : error.message;
    }
    isDev() && console.log('ErrorsCaptureWrapperApi errorText', errorText);
    ErrorsCapture({
        error: error,
        tag: 'api-request',
        ApiUrl: apiUrl,
        RequestType: requestType,
        RequestPayload: requestPayload,
        ErrorReason: errorText,
        ErrorType: errorType,
        alertTitle: title,
        alertDuration: duration,
        showAlertReportBtn: showAlertReportBtn,
        isOnlyAlert: !!isOnlyAlert
    });
};
ErrorsCaptureWrapperApi = isTraceable(ErrorsCaptureWrapperApi);
export { ErrorsCaptureWrapperApi };
